module.exports = __webpack_public_path__ + "img/image_35.65965b04.png";